import React, { useState } from 'react'
import { FaSearch, FaUserPlus } from 'react-icons/fa'
import UserCard from './UserCard'

const SearchTab = ({ searchResults, searchLoading, onSearch, onSendRequest, loading }) => {
  const [searchQuery, setSearchQuery] = useState('')
  const [customMessage, setCustomMessage] = useState("Hi there! I'd like to connect with you on MainStage!")

  const handleSearch = () => {
    onSearch(searchQuery)
  }

  const handleSendRequest = (userId, userFullName) => {
    const personalizedMessage = customMessage.replace(/\{name\}/g, userFullName || 'there')
    onSendRequest(userId, personalizedMessage)
  }

  return (
    <div>
      <h2 className="text-2xl font-semibold text-white mb-6">Find New Friends</h2>

      {/* Search Input */}
      <div className="flex gap-2 sm:gap-4 mb-6">
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
          placeholder="Search by rave alias..."
          className="flex-1 px-3 sm:px-4 py-2 sm:py-3 text-sm sm:text-base bg-white/5 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
        />
        <button
          onClick={handleSearch}
          disabled={searchLoading || !searchQuery.trim()}
          className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 disabled:from-gray-600 disabled:to-gray-600 text-white font-semibold py-2 px-3 sm:py-3 sm:px-6 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300 disabled:transform-none disabled:cursor-not-allowed flex items-center justify-center"
        >
          {searchLoading ? (
            <div className="w-4 h-4 sm:w-5 sm:h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
          ) : (
            <FaSearch className="w-4 h-4 sm:w-5 sm:h-5" />
          )}
        </button>
      </div>

      {/* Custom Message */}
      <div className="mb-6">
        <label className="block text-white font-medium mb-2">
          Friend Request Message
        </label>
        <textarea
          value={customMessage}
          onChange={(e) => setCustomMessage(e.target.value)}
          placeholder="Write a personal message to send with your friend requests..."
          rows={3}
          className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent resize-none"
        />
        <p className="text-xs text-gray-400 mt-1">
          Tip: Use {"{name}"} to automatically insert the person's name
        </p>
      </div>

      {/* Search Results */}
      <div className="space-y-4">
        {searchResults.map((user) => (
          <UserCard
            key={user._id}
            user={user}
            actions={
              user.friendshipStatus === 'accepted' ? (
                <span className="text-green-400 font-medium">✓ Friends</span>
              ) : user.friendshipStatus === 'pending' ? (
                <span className="text-yellow-400 font-medium">⏳ Request Sent</span>
              ) : user.canSendRequest ? (
                <button
                  onClick={() => handleSendRequest(user._id, user.fullName || user.username)}
                  disabled={loading}
                  className="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg text-sm sm:text-base font-medium transition-colors flex items-center gap-1 sm:gap-2"
                >
                  <FaUserPlus className="w-3 h-3 sm:w-4 sm:h-4" />
                  <span className="hidden sm:inline">Add Friend</span>
                  <span className="sm:hidden">Add</span>
                </button>
              ) : (
                <span className="text-gray-500">Can't send request</span>
              )
            }
          />
        ))}

        {searchResults.length === 0 && searchQuery && !searchLoading && (
          <div className="text-center py-8">
            <p className="text-gray-400">No users found matching your search</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default SearchTab